var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParticipants(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 61
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-12-10h80v80h-80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.952 35C11.222 35 2 42.843 2 57.11V59h52v-1.89C53.905 42.843 44.684 35 27.952 35zM28 31c7.108 0 13-6.735 13-14.968C41 7.987 35.388 2 28 2S15 8.08 15 16.032C15 24.358 20.892 31 28 31z",
    fillRule: "nonzero",
    stroke: "#B4BFD5",
    strokeWidth: 3
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NiIgaGVpZ2h0PSI2MSIgdmlld0JveD0iMCAwIDU2IDYxIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTS0xMi0xMGg4MHY4MGgtODB6Ii8+CiAgICAgICAgPGcgZmlsbC1ydWxlPSJub256ZXJvIiBzdHJva2U9IiNCNEJGRDUiIHN0cm9rZS13aWR0aD0iMyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0yNy45NTIgMzVDMTEuMjIyIDM1IDIgNDIuODQzIDIgNTcuMTFWNTloNTJ2LTEuODlDNTMuOTA1IDQyLjg0MyA0NC42ODQgMzUgMjcuOTUyIDM1ek0yOCAzMWM3LjEwOCAwIDEzLTYuNzM1IDEzLTE0Ljk2OEM0MSA3Ljk4NyAzNS4zODggMiAyOCAyUzE1IDguMDggMTUgMTYuMDMyQzE1IDI0LjM1OCAyMC44OTIgMzEgMjggMzF6Ii8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgParticipants as ReactComponent };